module.exports = __webpack_public_path__ + "static/app_promo-147259b7dad5fbf49f944b2ba0bc9685.png";